import { render } from "./AbdicateGovernor.vue?vue&type=template&id=140a561c"
import script from "./AbdicateGovernor.vue?vue&type=script&lang=js"
export * from "./AbdicateGovernor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/windowOverlay/AbdicateGovernor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "140a561c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('140a561c', __exports__)) {
    api.reload('140a561c', __exports__)
  }
  
  module.hot.accept("./AbdicateGovernor.vue?vue&type=template&id=140a561c", () => {
    api.rerender('140a561c', render)
  })

}


export default __exports__